import React, { useEffect, useState } from 'react'
import { Horse } from '../api'
import { horsesState } from '../state/Horses.state'

const horses = new Map<string, Horse>()

export const HorseByRegId = ({ regId }: { regId?: string | null }) => {
  /* STATE */
  const [horse, setHorse] = useState<Horse | undefined>(undefined)

  /* EFFECTS */
  useEffect(() => {
    if (regId) {
      if (horses?.has(regId)) {
        setHorse(horses?.get(regId))
      } else {
        horsesState
          .fetchHorseById(regId)
          .then((horse) => {
            setHorse(horse)
            if (horse) {
              horses.set(regId, horse)
            }
          })
          .catch(console.error)
      }
    }
  }, [regId])

  /* TEMPLATE */
  if (!horse) return <span>n.a.</span>
  return <span>{horse?.name}</span>
}
